import { css } from '@emotion/react';
import { AllIcons } from '../Icons';
import { LAYOUT2, TYPOGRAPHY2 } from '../Styles';
import { Button } from '../Widgets/Button';

const NO_RECORDS_PLACEHOLDER_STYLE = css`
  label: NO_RECORDS_PLACEHOLDER_STYLE;
  ${TYPOGRAPHY2.xLargeBold}
  color: var(--text);
  display: flex;
  align-items: center;
  max-width: 500px;
  flex-direction: column;
  gap: ${LAYOUT2.spacing2}px;
  text-align: center;

  button {
    width: fit-content;
  }
`;
const NO_RECORDS_PLACEHOLDER_STYLE_WRAPPER = css`
  label: NO_RECORDS_PLACEHOLDER_STYLE_WRAPPER;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: ${LAYOUT2.spacing8}px;
  height: 100%;
`;
const titleStyle = css`
  color: var(--text);
  ${TYPOGRAPHY2.xLargeBold}
  line-height: 1; // make layout tight around the title - matches xLargeBold's font-size exactly
`;
const descriptionStyle = css`
  color: var(--text);
  ${TYPOGRAPHY2.small}
`;

export type IconType = 'folder' | 'camera' | 'property';

export const NoRecordsPlaceholder = (
  { createFirstRecord, recordType, description, createButtonText, iconType, qualifier }: {
    createFirstRecord?: () => void;
    qualifier?: string;
    recordType: string;
    description: string;
    createButtonText?: string;
    iconType?: keyof typeof AllIcons;
  },
) => {
  const Icon = iconType ? AllIcons[iconType] : null;
  return (
    <div css={NO_RECORDS_PLACEHOLDER_STYLE_WRAPPER}>
      <div css={NO_RECORDS_PLACEHOLDER_STYLE}>
        {Icon && <Icon width={100} height={100} />}
        <div css={titleStyle}>No {qualifier} {recordType}</div>
        <div css={descriptionStyle}>{description}</div>
        {createFirstRecord && (
          <Button onClick={createFirstRecord}>
            {createButtonText ?? 'Create First ' + recordType}
          </Button>
        )}
      </div>
    </div>
  );
};
